import Column from '@components/Column';
import Text from '@components/Text';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    color?: string;
    size?: 'full' | 'small';
}

function Loading({ color, size = 'full' }:Props) {
    const { t } = useTranslation('common');
    if (size === 'small') {
        return (
            <Column align='center'
                fullWidth
                className={styles.small}>
                <span className={styles.loader}/>
            </Column>
        );
    }
    return (<Column align='center' justify='center'
        spacing={16}
        fullWidth fullHeight>
        <span className={styles.loader}/>
        <Text fontWeight='medium' color={color}>{t('loading')}</Text>
    </Column>);
}

export default Loading;
